var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65 21.5L5.75 18.25L1.975 17.475L2.4 13.8L0 11L2.4 8.225L1.975 4.55L5.75 3.775L7.65 0.5L11 2.05L14.35 0.5L16.275 3.775L20.025 4.55L19.6 8.225L22 11L19.6 13.8L20.025 17.475L16.275 18.25L14.35 21.5L11 19.95L7.65 21.5ZM8.325 19.525L11 18.4L13.75 19.525L15.425 17.025L18.35 16.275L18.05 13.3L20.075 11L18.05 8.65L18.35 5.675L15.425 4.975L13.7 2.475L11 3.6L8.25 2.475L6.575 4.975L3.65 5.675L3.95 8.65L1.925 11L3.95 13.3L3.65 16.325L6.575 17.025L8.325 19.525ZM9.925 14.325L15.6 8.7L14.475 7.675L9.925 12.175L7.55 9.7L6.4 10.825L9.925 14.325Z",
    className: "fill",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/default-icon.23d8f094ebc1a91733dc5423161cebd1.svg";
export { ForwardRef as ReactComponent };